import { inject, InjectionToken, WritableSignal } from '@angular/core';
import { PatientBehaviorAntecedentModel, PatientBehaviorConsequenceModel, PatientBehaviorDataModel, PatientBehaviorLocationModel, PatientBehaviorModel, PatientBehaviorResponseModel, PatientBehaviorSeverityModel, PatientSessionModel, PatientTargetDataModel } from '../api/models';
import { PatientSessionService } from '../../staff/home/patient-session.service';

/** The operations shared collection controls need, independent of the signed-in audience. */
export interface SessionDataSource {
  dataChanged: WritableSignal<number>;
  getPatientSession(): PatientSessionModel | null;
  getTargetData(targetID: number): PatientTargetDataModel[] | null;
  getAllTargetDataForTarget(targetID: number): PatientTargetDataModel[];
  addTargetData(data: PatientTargetDataModel): void;
  saveTargetData(data: PatientTargetDataModel): void;
  getBehaviorData(behaviorID: number): PatientBehaviorDataModel[] | null;
  addBehaviorData(data: PatientBehaviorDataModel): void;
  saveBehaviorData(data: PatientBehaviorDataModel, originalRecordedDate?: string): void;
  getPatientBehaviors(): PatientBehaviorModel[];
  getPatientBehaviorLocations(): PatientBehaviorLocationModel[];
  getPatientBehaviorResponses(): PatientBehaviorResponseModel[];
  getPatientBehaviorSeverities(): PatientBehaviorSeverityModel[];
  getPatientBehaviorConsequences(): PatientBehaviorConsequenceModel[];
  getPatientBehaviorAntecedents(): PatientBehaviorAntecedentModel[];
  getTargetsRunningData(sessionID: number, targetID: number): {SessionID: number; TargetID: number; Data: any} | null;
  setTargetsRunningData(sessionID: number, targetID: number, data: any): void;
  claimIntervalCompletion(sessionID: number, targetID: number, startTime: number): boolean;
  completeInterval(sessionID: number, targetID: number, startTime: number): boolean;
}

export const SESSION_DATA_SOURCE = new InjectionToken<SessionDataSource>('Spark session data source', {
  providedIn: 'root',
  factory: () => inject(PatientSessionService),
});
